{
  "app.title": "Questback - Answer Module",
  "common.complete": "complete",
  "common.remove": "Remove",
  "common.retry": "Retry",
  "common.selectfile": "Select File",
  "common.upload": "Upload",
  "common.uploaded": "Uploaded",
  "error.sessionnotfound": "Session not found",
  "error.statenotfound": "State not found",
  "error.statesuperseded": "Your personal invitation link has been used another place or by someone else",
  "error.surveynolongeravailable": "Survey no longer available",
  "editresponse.confirmation.title": "Confirm Changes",
  "editresponse.confirmation.message": "Are you sure you want to save your changes to this response?",
  "editresponse.confirmation.save": "Save Changes",
  "editresponse.confirmation.cancel": "Cancel",
  "editresponse.saved.message": "Your changes have been saved successfully",
  "fileupload.dropzone.hint": "Upload file or drag & drop file here",
  "fileupload.error.badrequest": "We couldn’t process this file. Please check it and try again.",
  "fileupload.error.filetoolarge": "The file is too large. Please choose a smaller file",
  "fileupload.error.forbidden": "File upload is not allowed. Please contact support.",
  "fileupload.error.networkerror": "Network connection error. Please check your internet connection.",
  "fileupload.error.notfound": "Upload service is not available. Please try again later.",
  "fileupload.error.servererror": "Server error occurred. Please try again later.",
  "fileupload.error.serviceunavailable": "Upload service is temporarily unavailable. Please try again later.",
  "fileupload.error.timeout": "Upload timed out. Please try again with a smaller file.",
  "fileupload.error.unauthorized": "You are not authorized to upload files. Please log in and try again.",
  "fileupload.error.unsupportedfiletype": "File type is not supported. Please select a different file.",
  "fileupload.error.uploadfailed": "Upload failed. Please try again.",
  "fileupload.fileselected": "File selected",
  "fileupload.removeinstruction": "Click to remove the uploaded file",
  "fileupload.select": "Select File",
  "fileupload.uploadcomplete": "File uploaded successfully",
  "fileupload.uploadfailed": "Upload failed for this file",
  "fileupload.uploadprogress": "Upload progress: {{progress}}%",
  "fileupload.uploading": "Uploading...",
  "gdpr.notparticipate.cancel.button": "Cancel",
  "gdpr.notparticipate.closedialog.button": "Close",
  "gdpr.statement.closedialog.button": "Close",
  "gdpr.statement.field.automateddecisionmaking.respondentname": "Automated decision making",
  "gdpr.statement.field.categoriesofrecipients.respondentname": "Who will have access to your personal data",
  "gdpr.statement.field.controllername.respondentname": "How to contact us",
  "gdpr.statement.field.dataprotectionofficer.respondentname": "Our data protection officer",
  "gdpr.statement.field.datasubjectrights.respondentname": "Your individual rights",
  "gdpr.statement.field.legalbasisforprocessing.respondentname": "Legal basis for processing your personal data",
  "gdpr.statement.field.personaldatacategories.respondentname": "What special categories of personal data will be collected and used",
  "gdpr.statement.field.personaldatatypes.respondentname": "What type of personal data will be collected and used",
  "gdpr.statement.field.processingperiodcriteria.respondentname": "How long will personal data be processed",
  "gdpr.statement.field.representativename.respondentname": "Our EU representative",
  "gdpr.statement.field.statutoryorcontractualreq.respondentname": "Statutory or contractual requirement",
  "gdpr.statement.field.supervisoryauthorityinfo.respondentname": "Supervisory authority",
  "gdpr.statement.field.transferofdataexternally.respondentname": "Transfer of data to non-EU/EEC country or international organisation, and safeguards (if applicable)",
  "gdpr.statement.field.withdrawconsentinfo.respondentname": "Your right to withdraw consent",
  "gdpr.statement.getmoreinfo": "Click here for more information about how your personal data is processed",
  "gdpr.statement.infoaboutdataprocessing": "Information about data processing",
  "gdpr.statement.notparticipate": "I don't want to participate in this survey",
  "gdpr.statement.notparticipate.dialogcontent": "Once you confirm, you will not be able to participate in the survey anymore",
  "gdpr.statement.notparticipate.dialogheader": "Are you sure you don't want to participate in the survey?",
  "gdpr.statement.notparticipate.receiptcontent": "The survey participation has been rejected. Many thanks for your interest.",
  "gdpr.statement.notparticipate.receiptheader": "Participation rejected",
  "gdpr.statement.processingagree": "I agree to the processing of my personal data in accordance with the information provided herein.",
  "gdpr.statement.retention.day": "Day",
  "gdpr.statement.retention.days": "Days",
  "gdpr.statement.retention.month": "Month",
  "gdpr.statement.retention.months": "Months",
  "gdpr.statement.retention.week": "Week",
  "gdpr.statement.retention.weeks": "Weeks",
  "gdpr.statement.retention.year": "Year",
  "gdpr.statement.retention.years": "Years",
  "gdpr.statement.retention.unlimited": "Unlimited",
  "gotopage.continue.button": "Go back to the question",
  "gotopage.header": "Questback Information",
  "gotopage.quota.explanation": "The option you selected in the previous question has reached its quota. Please go back and choose a different alternative to continue.",
  "gotopage.quota.fallbacktext": "The quota is full.",
  "gotopage.startfrombeginning.button": "Start over from the beginning",
  "gotopage.whattodo": "Please choose how you’d like to continue with this survey",
  "information.collectemail.text": "Please enter your e-mail address",
  "information.quest.hasnotstarted": "This Survey is not available until <date>. Please try again then.",
  "information.quest.isclosed": "This Survey was closed on <date>. Thank you for your interest.",
  "information.quest.isnotsupported": "You need an invitation to participate in this survey",
  "information.quest.multipleresponsenotallowed": "You have already answered and can only respond once to this survey",
  "information.quest.notpublished": "This Survey is not published yet. Please try again later.",
  "information.respondent.hasdeclinedgdpr": "You have rejected to participate in this survey",
  "language.aria.controls.labels": "Language selection",
  "language.aria.select": "Select {{value}}",
  "language.aria.topbar.logo.alt": "Company logo",
  "language.header": "Please choose your language",
  "navigation.adjusterror.button": "Click to adjust errors ({{count}})",
  "navigation.back.button": "Back",
  "navigation.highcontrast.button": "Turn high contrast on or off",
  "navigation.highcontrast.label": "Contrast",
  "navigation.next.button": "Next",
  "navigation.next.buttondescription": "This button is currently disabled",
  "navigation.skip.maincontent": "Skip to main content",
  "navigation.submit.button": "Send",
  "page.error.title": "Questback - Error",
  "page.gdpr.title": "Questback - Consent page",
  "page.gotopage.title": "Questback - Go back to question",
  "page.information.title": "Questback - Information",
  "page.invitation.title": "Questback - Invitation",
  "page.language.title": "Questback - Language",
  "page.password.title": "Questback - Password",
  "page.preview.title": "Questback - Preview",
  "page.print.title": "Questback - Print",
  "page.startover.title": "Questback - Start Over",
  "page.survey.title": "Questback - Survey",
  "page.theme.title": "Questback - Theme",
  "password.body": "To access this Quest, simply provide the password you have received. If you haven't received a password, please contact the person who invited you.",
  "password.header": "Password Protected Quest",
  "password.inputheader": "Password",
  "powered.by": "Powered by:",
  "preview.action.gotocompletepage": "If “{{alternative}}” is selected, respondent will be presented with Thank You Note",
  "preview.action.header": "Alternatives set up with actions:",
  "preview.action.redirect": "If “{{alternative}}” is selected, respondent will be redirected to {{url}}",
  "preview.condition.alternativeonlyshownifconditionsaremet": "The alternative “{{alternative}}” will only be shown if the following conditions are met:",
  "preview.condition.alternativequestion": "“{{questionname}}” contains {{operator}} the alternatives",
  "preview.condition.calendarquestion": "“{{questionname}}” {{operator}} {{value}}",
  "preview.condition.casesensitive": "case sensitive",
  "preview.condition.conditionsmustbefulfilled": "These conditions must be met to",
  "preview.condition.conditionsmustbefulfilledforquestionbelow": "The question below will only be shown if the following conditions are met:",
  "preview.condition.interval": "Answer given {{operator}} {{value}}",
  "preview.condition.language": "Answered in {{operator}}",
  "preview.condition.numericscoreobtained": "if the currently obtained score is {{operator}} {{value}}",
  "preview.condition.operator.allof": "all of",
  "preview.condition.operator.and": "and",
  "preview.condition.operator.answered": "answered",
  "preview.condition.operator.anyof": "any of",
  "preview.condition.operator.beginswith": "begins with",
  "preview.condition.operator.contains": "contains",
  "preview.condition.operator.dateafter": "After",
  "preview.condition.operator.datebefore": "Before",
  "preview.condition.operator.datebetween": "Between",
  "preview.condition.operator.dateequal": "equals",
  "preview.condition.operator.doesnotbeginwith": "Does not begin with ",
  "preview.condition.operator.doesnotcontain": "does not contain",
  "preview.condition.operator.doesnotendwith": "does not end with",
  "preview.condition.operator.endswith": "ends with",
  "preview.condition.operator.isafter": "is after",
  "preview.condition.operator.isbefore": "is before",
  "preview.condition.operator.isbetween": "is between",
  "preview.condition.operator.isequal": "is equal to",
  "preview.condition.operator.isequalorhigherthan": "is equal to or higher than",
  "preview.condition.operator.isequalorlowerthan": "is equal or lower than",
  "preview.condition.operator.isnotdate": "Is not a date",
  "preview.condition.operator.isnotequalto": "is not equal to",
  "preview.condition.operator.noneof": "none of",
  "preview.condition.operator.notanswered": "not answered",
  "preview.condition.operator.or": "or",
  "preview.condition.rowonlyshownifconditionsaremet": "The row “{{questionname}}” will only be shown if the following conditions are met:",
  "preview.condition.statusquestion": "“{{questionname}}” is {{operator}}",
  "preview.condition.textquestion": "“{{questionname}}” {{operator}} the text “{{value}}”",
  "preview.condition.tobeshown": "to be shown",
  "preview.condition.unknown": "Unknown",
  "preview.label.apply": "Apply",
  "preview.label.closemenu": "Close menu",
  "preview.label.copylink": "Copy link",
  "preview.label.desktop": "Desktop",
  "preview.label.devicepreview": "Select device",
  "preview.label.freenavigation": "Preview",
  "preview.label.gdprpage": "Consent page",
  "preview.label.goto": "Go To ",
  "preview.label.hide": "Hide",
  "preview.label.ignore": "Off",
  "preview.label.language": "Language",
  "preview.label.languagepage": "Language",
  "preview.label.mobile": "Mobile",
  "preview.label.on": "On",
  "preview.label.openmenu": "Open menu",
  "preview.label.passwordpage": "Password",
  "preview.label.previewtitle": "Preview",
  "preview.label.print": "Print",
  "preview.label.rulesintext": "Conditions as text",
  "preview.label.show": "Show",
  "preview.label.simulateresponse": "Simulate response",
  "preview.label.tablet": "Tablet",
  "preview.label.testmode": "Free navigation or Simulate response",
  "preview.label.testmode.tooltip": "Free navigation let you jump between pages and preview them. Simulate response starts at the survey start and triggers conditions, actions and mandatory fields",
  "preview.label.thankyoupage": "Thank you note",
  "preview.label.userules": "Apply Conditions",
  "preview.label.welcomepage": "Quest Introduction",
  "preview.quota.generalrow": "“{{alternative}}” allows up to {{quotacount}} responses",
  "preview.quota.header": "Alternatives set up with quota:",
  "question.fileupload.legaltext": "By uploading this file, I confirm that the uploaded file does not have illegal content, and that my sharing the file does not infringe a third party’s rights.",
  "question.multiselect.maximumselected": "You can select up to {{maxSelections}} options. Deselect one to pick another.",
  "question.prioritydragdrop.availableitems": "Alternatives to rank",
  "question.prioritydragdrop.priodown": "Move {{title}} down",
  "question.prioritydragdrop.prioup": "Move {{title}} up",
  "question.prioritydragdrop.selecteditems": "Selected alternatives",
  "question.prioritydragdrop.selectlabel": "Select {{title}}",
  "question.prioritydragdrop.unselectlabel": "Unselect {{title}}",
  "question.requiredlabel": "Required",
  "question.satisfaction.neutral": "Neutral",
  "question.satisfaction.satisfied": "Satisfied",
  "question.satisfaction.unsatisfied": "Dissatisfied",
  "question.satisfaction.verysatisfied": "Very Satisfied",
  "question.satisfaction.veryunsatisfied": "Very Dissatisfied",
  "question.singleselectdropdown.placeholder": "Select an option",
  "question.singleselect.otherinputlabel": "Type your answer ",
  "question.slider.arialabel.prefix": "Slider for ",
  "question.slider.arialabel.separator": "to ",
  "question.slider.clear.button": "Clear",
  "startover.continue.button": "Continue where I left",
  "startover.header": "You have an unfinished response to this survey. You can continue where you left off or start over. Starting over will remove all previous answers.",
  "startover.startfrombeginning.button": "Start from the beginning",
  "startover.whattodo": "Please choose how you’d like to proceed",
  "survey.progress.label": "Progress",
  "thankyou.sendreceipt.button": "Send copy",
  "thankyou.sendreceipt.copytoemailaddress": "Email a copy of my response to this address",
  "thankyou.sendreceipt.emailissent": "A copy of your response has been sent to the provided e-mail address.",
  "thankyou.sendreceipt.invalidemailaddress": "The email address you entered isn’t valid. Please enter a valid email address.",
  "validation.collectemail.invalidemailformat": "is not a valid email address",
  "validation.collectemail.shouldnotbecollected": "Email address cannot be collected",
  "validation.fileupload.invalidfilename": "File name contains invalid characters",
  "validation.fileupload.uploadidnotfound": "File not found",
  "validation.gdpr.noconsentneed": "Survey does not have consent approval",
  "validation.gdpr.revisionidcannotbezero": "RevisionId is zero or StatementId is zero",
  "validation.gdpr.statementidandrevisionidonsamestatement": "RevisionId and StatementId is not part of the statement for the approval",
  "validation.gdpr.statementidcannotbezero": "RevisionId is zero or StatementId is zero",
  "validation.general.dataerror": "Validation cannot be made because data error or corruption",
  "validation.general.doesnotbelongincurrentstate": "Response sent cannot be saved in the current state",
  "validation.general.emailshouldnotbecollected": "Pleace do not send you email, it should not be collected for this survey.",
  "validation.general.mandatory": "Mandatory",
  "validation.general.missingconsentanswer": "Gdpr consent answer is missing",
  "validation.general.missinghiddenanswer": "Hidden personal information answer is missing",
  "validation.general.questiontypemappingerror": "Question and answer does not map",
  "validation.hidden.cannotbechanged": "If the hidden cannot be changed",
  "validation.hierarchical.answerisnotvalid": "Answer is not valid (When the answers is not aligned in the tree structure of possible answers.)",
  "validation.hierarchical.idisnotavailableforthislevel": "Id is not available for this level",
  "validation.inline.general.invalidformat.custom": "Please use the format: {{formatPattern}} (A=letter, 9=number, _=space, %=any character combination of any length)",
  "validation.inline.general.invalidformat.date": "Please use the format: Date (e.g., 01.07.1984)",
  "validation.inline.general.invalidformat.decimal": "Please use the format: Decimal (e.g., -9,99 or +9.99)",
  "validation.inline.general.invalidformat.email": "Please use the format: Email (e.g., firstname.lastname@example.com)",
  "validation.inline.general.invalidformat.fourletters": "Please use the format: Four letters (e.g., John)",
  "validation.inline.general.invalidformat.fournumbers": "Please use the format: Four numbers (e.g., 4321)",
  "validation.inline.general.invalidformat.integer": "Please use the format: Integer (e.g., 23 or -54)",
  "validation.inline.general.invalidformat.lettersonly": "Please use the format: Letters only (e.g., Europe)",
  "validation.inline.general.invalidformat.numbersonly": "Please use the format: Numbers only (e.g., 123432)",
  "validation.inline.general.invalidformat.timewithoutseconds": "Please use the format: Time without seconds (e.g., 10:30)",
  "validation.inline.general.invalidformat.timewithseconds": "Please use the format: Time with seconds (e.g., 10:30:24)",
  "validation.inline.general.maxlength": "Maximum length of {{required}} characters exceeded. You entered {{actual}} characters",
  "validation.inline.general.maxselections": "You can select up to {{maxSelections}} items",
  "validation.inline.general.requiredselect": "You need to select a value for {{title}}",
  "validation.inline.general.requiredtext": "You need to fill in a value",
  "validation.language.cannotbechanged": "Language cannot be changed",
  "validation.language.notavailable": "Selected language is not available for this survey",
  "validation.multiselect.alternativnotavailable": "This alternative is no longer available",
  "validation.multiselect.othertextmissing": "Please provide text for the Other option",
  "validation.multiselect.othertextshouldnothavetext": "The Other field must be empty",
  "validation.multiselect.othertexttoolong": "Maximum 255 characters allowed",
  "validation.multiselect.toomanyselected": "Too many options selected",
  "validation.password.incorrect": "Incorrect password",
  "validation.prioritydraganddrop.alternativenotavailable": "This alternative is no longer available",
  "validation.prioritydraganddrop.toomanyselected": "Too many alternatives ranked",
  "validation.prioritydropdown.answerisnotvalid": "Answer is not valid",
  "validation.prioritydropdown.duplicateanswer": "Duplicate answer, expected unique answers for this component.",
  "validation.quota.alternativereached": "Quota for alternative “{{alternativeTitle}}” has been reached. Please select a different answer.",
  "validation.reset.cannotresetincurrentstate": "If the question does not exists in the current state",
  "validation.responsereceipt.invalidemailaddress": "Invalid email format",
  "validation.responsereceipt.mandatory": "Enter an email address to receive a Copy of your response",
  "validation.responsereceipt.receipthasalreadybeensent": "A Copy of response has already been sent",
  "validation.responsereceipt.receiptisnotavailable": "Receipt is not available for this response",
  "validation.singleselect.alternativnotavailable": "Alternative is not available for selection",
  "validation.singleselect.othertextmissing": "Please provide text for the Other option",
  "validation.singleselect.othertextshouldnothavetext": "The Other field must be empty",
  "validation.singleselect.othertexttoolong": "Maximum 255 characters allowed",
  "validation.text.invalidformat.general": "Text format is invalid",
  "validation.text.toolong255": "Maximum 255 characters allowed",
  "validation.text.toolong4000": "Maximum 4000 characters allowed",
  "welcome.hiddenidentity.hidden.title": "Your identity will be hidden.",
  "welcome.hiddenidentity.information": "When hidden identity is used in surveys, no identifiable information, such as browser type and version, operating system, or e-mail address, will be stored with the answer. This is to protect the respondent’s identity.",
  "welcome.hiddenidentity.optional.title": "Hide my identity"
}
